export const breakpointXS = '375px';
export const breakpointSM = '576px';
export const breakpointMD = '768px';
export const breakpointLG = '1024px';
export const breakpointXL = '1200px';
export const breakpointXXL = '1600px';
//# sourceMappingURL=breakpoints.js.map